var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroupedCol(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 53,
    viewBox: "0 0 105 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_2804)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.579102,
    width: 103.579,
    height: 52.8684,
    rx: 2.90977,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.97379,
    y: 46.8741,
    width: 5.99415,
    height: 5.99415,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7337,
    y: 29.4292,
    width: 5.58076,
    height: 23.4392,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.2892,
    y: 29.4292,
    width: 5.58076,
    height: 23.4392,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.8445,
    y: 20.5,
    width: 5.58076,
    height: 32.3684,
    fill: "#A2ABCC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.1667,
    y: 42.0789,
    width: 5.99415,
    height: 10.7895,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.4307,
    y: 32.7777,
    width: 5.58076,
    height: 20.0907,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.9861,
    y: 30.5456,
    width: 5.58076,
    height: 22.323,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.5414,
    y: 27.1971,
    width: 5.58076,
    height: 25.6715,
    fill: "#6371A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.3598,
    y: 44.4765,
    width: 5.99415,
    height: 8.39181,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.1276,
    y: 46.1713,
    width: 5.58076,
    height: 6.69692,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.6829,
    y: 47.2877,
    width: 5.58076,
    height: 5.58076,
    fill: "#DADFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.2384,
    y: 41.707,
    width: 5.58076,
    height: 11.1615,
    fill: "#DADFF2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_2804"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.579102,
    width: 103.579,
    height: 52.8684,
    rx: 2.90977,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupedCol);
export default __webpack_public_path__ + "static/media/grouped-col.a289e6e9a9549bf7f8d10525100ebe81.svg";
export { ForwardRef as ReactComponent };